export interface IRegExAssociation {
  regex: string;
  display: string;
}

export const REGEX_ASSOCIATIONS: IRegExAssociation[] = [
  {
    regex: '^true$',
    display: $localize`Boolesch-Wert ist Wahr`,
  },
  {
    regex: '^false$',
    display: $localize`Boolesch-Wert ist Falsch`,
  },
  {
    regex: '(.|\\s)*\\S(.|\\s)*',
    display: $localize`Irgendetwas wurde eingetragen, Leertasten werden ignoriert`,
  },
  {
    regex: '\\d{5}',
    display: $localize`Zahl mit einer festen Länge von 5`,
  },
  {
    regex: 'beispiel',
    display: $localize`Text beinhaltet den Text ` + 'beispiel',
  },
  {
    regex: '^beispiel',
    display: $localize`Text startet mit dem Text ` + 'beispiel',
  },
  {
    regex: 'beispiel$',
    display: $localize`Text endet mit dem Text ` + 'beispiel',
  },
];
